export class ApiConfig {
    static readonly LoginPath = 'account/login';
    static readonly LogoutPath = 'account/logout';
    static readonly RefreshTokenPath = 'account/refreshToken';
    static readonly AccessTokenObjectKey = 'access_token';
    static readonly RefreshTokenObjectKey = 'refresh_token';
    static readonly SetLanguagePath = 'common/setLanguage';
    static readonly ClearCachePath = 'common/clearCache';
}
